import { useMatch } from 'react-router'

import { T } from '@tribeplatform/react-components/i18n'

export const AppearanceColorsSidebarTitle = () => {
  const match = useMatch('/manage/appearance/colors')

  if (!match) {
    return (
      <div className="flex justify-between items-center flex-grow">
        <T defaultMessage="Themes" id="Generics.Themes" />
      </div>
    )
  }

  return null
}
